module.exports = __webpack_public_path__ + "static/enhancedLTVbg-b577c81051ebc7168960d4d571e1b837.jpg";